module.exports = __webpack_public_path__ + "7f3f008ff5f77e83016df2d2e1d7ab0d.pdf";